module.exports = __webpack_public_path__ + "media/images/logo__hyflyersgc-e0ec668ff94fe3704a984bb6192ebeaa.png";